import PaymentLayout from './PaymentLayout';

export default PaymentLayout;
